exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reports h2[data-v-6506f85a]{text-align:center;margin:50px 0}.reports h2 span[data-v-6506f85a]{display:block}.reports h2 .lighter[data-v-6506f85a]{margin-top:15px;font-size:16px}.error[data-v-6506f85a]{font-size:22px;margin:50px 0;text-align:center;color:rgba(0,0,0,.87);font-weight:400}.single-table[data-v-6506f85a]{margin-top:75px}.single-table[data-v-6506f85a]:last-of-type{margin-bottom:50px}.single-table h3[data-v-6506f85a]{margin-left:20px}.reports-table[data-v-6506f85a]{max-width:900px}.reports-table .md-table-cell[data-v-6506f85a]:not(:first-of-type),.reports-table .md-table-head[data-v-6506f85a]:not(:first-of-type){text-align:right}.reports-table .md-table-cell[data-v-6506f85a]{text-transform:capitalize}.reports-table .md-table-row[data-v-6506f85a]:last-of-type{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6506f85a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Subscriptions/ReportsPayment.vue
// module id = 451
// module chunks = 0